export default __webpack_public_path__ + "static/media/telugu_h.e014dc68.png";